import type {ReactNode} from "react";
import cn from "classnames";

/**
 * A collapsible list of checkboxes in the Defaults panel. The summary names
 * the list and says what is changed in it; `isChanged` colours that note.
 */
export default function CheckboxGroup({
  title,
  summary,
  isChanged,
  className,
  children,
}: {
  title: string;
  summary: string;
  isChanged: boolean;
  className?: string;
  children: ReactNode;
}) {
  return (
    <details className="selector-visibility-group">
      <summary className="selector-visibility-summary">
        <span>{title}</span>
        <span className={cn("selector-visibility-count", {"has-hidden": isChanged})}>{summary}</span>
      </summary>
      <div className={cn("selector-visibility-list", className)}>{children}</div>
    </details>
  );
}
